import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Col, Row, Form} from 'antd';
import ConfirmationModal from 'shared/components/ConfirmModal';
import Input from 'shared/components/Input';
import {connect} from 'react-redux';
import Container from 'shared/components/Container';
import { useTranslation } from 'react-i18next';
import {
  deleteVolunteer, updateVolunteerInfo
} from 'features/AdminDashboard/redux/actions/volunteersActions';

import BtnPrimary from 'shared/components/Button/BtnPrimary';
import BtnSecondary from 'shared/components/Button/BtnSecondary';

const rowProps = {
    type: 'flex', gutter: 20,
    className: 'm-t-20'
  };
  
  const colProps = {
    xs: 24,
    md: 16
  }
const FormItem = Form.Item;

const EditVolunteerContent = props => {

  const {
    selectedEditVolunteer,
    handleDelete,
    isDeletingVolunteer,
    isUpdatingVolunteer,
    closeModal,
    handleUpdate
  } = props;

  const {
    id, email, firstName, lastName, mobilePhone
  } = selectedEditVolunteer;


  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const { t } = useTranslation();
  const [form] = Form.useForm();

 
  const cancelDelete = () => {
    setDeleteModalVisible(false);
  };

  const onDeleteClick = () => {
    setDeleteModalVisible(true);
  };

  const onclose =async () => {
    closeModal();
  }

  const onDeleteVolunteer = async () => {
    await handleDelete(id);
    setDeleteModalVisible(false);
    await onclose();
  };

  const onSaveClick = (e) => {
    if (e && 'preventDefault' in e) e.preventDefault();
    form.validateFields().then(async (values, err) => {
            
     await handleUpdate(id, values);
    });
  };

  const onFinishFailed = ({ errorFields }) => {
    form.scrollToField(errorFields[0].name);
  };

  return (
    <Container type='medium'>
      <ConfirmationModal
        visible={deleteModalVisible}
        onCancel={cancelDelete}
        onSubmit={onDeleteVolunteer}
        title='Volunteer'
        description='Are you sure you want to remove this volunteer from all event role assignments?'
        loading={isDeletingVolunteer}
      />
 
        <Form onFinishFailed={onFinishFailed} form={form} initialValues={{ email: email, firstName: firstName, lastName: lastName, phone: mobilePhone }} hideRequiredMark onFinish={onSaveClick} name='EditVolunteer'>
        <Row {...rowProps}>
            <Col xs={24} md={16}>
            <FormItem name="email" label={t('emailLabel')}>
                <Input required disabled />
            </FormItem>
            </Col>
        </Row>
        <Row {...rowProps}>
            <Col {...colProps}>
            <FormItem name="firstName" label={t('firstNameLabel')} rules={[{ required: true, message: t('enterFirstNameLabel') }]}>
                <Input size='large' required />
            </FormItem>
            </Col>
        </Row>
        <Row {...rowProps}>
            <Col {...colProps}>
            <FormItem name="lastName" label={t('lastNameLabel')} rules={[{ required: true, message: t('enterLastNameLabel') }]}>
                <Input size='large' required />
            </FormItem>
            </Col>
        </Row>
        <Row {...rowProps}>
            <Col {...colProps}>
            <FormItem name="phone" label={t('phoneOptionalLabel')}>
                <Input size='large' />
            </FormItem>
            </Col>
        </Row>
        <Row {...rowProps} justify='space-between'>
            <Col xs={24} md={16} className='admin-dashboard__edit-modal-buttons'>
            <BtnPrimary
                disabled={isDeletingVolunteer || isUpdatingVolunteer}
                loading={isUpdatingVolunteer}
                htmlType='submit'
            >
                {t('saveLabel')}
            </BtnPrimary>
            <BtnSecondary
                disabled={isDeletingVolunteer || isUpdatingVolunteer}
                loading={isDeletingVolunteer}
                onClick={onDeleteClick}
            >
                Delete
            </BtnSecondary>
            </Col>
        </Row>
        </Form>
    </Container>
  );
};

EditVolunteerContent.propTypes = {
    visible: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    selectedEditVolunteer: PropTypes.object.isRequired,
    handleDelete: PropTypes.func.isRequired,
    handleUpdate: PropTypes.func.isRequired,
    isDeletingVolunteer: PropTypes.bool.isRequired,
    isUpdatingVolunteer: PropTypes.bool.isRequired
};

const mapStateToProps = ({ adminBoard }) => {
    const { volunteers: {
      selectedEditVolunteer,
      isDeletingVolunteer,
      isUpdatingVolunteer
    } } = adminBoard;
    return {
      selectedEditVolunteer,
      isDeletingVolunteer,
      isUpdatingVolunteer
    };
  };

const mapDispatchToProps = {
  handleDelete: deleteVolunteer,
  handleUpdate: updateVolunteerInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(EditVolunteerContent);